<template>
  <div>
    <div class="home-header">
      <div class="home-header-inner">欢迎进入面包财经应聘预约系统</div>
      <div class="home-header-circle"></div>
    </div>
    <div class="home-main">
      <div class="title">请选择您要进行的操作</div>
      <div class="sub-title gray">当前可进行预约操作以及查询操作</div>
    </div>
    <div class="operation-choose">
      <div class="operation-item subscribe" @click="goRouter('subscribe')">
        <span>应聘预约</span>
      </div>
      <div class="operation-item search" @click="goRouter('search')">
        <span>预约查询</span>
      </div>
    </div>
    <div class="warning-tip gray">本链接为您的预约笔试/面试/复试专属链接，仅供本人使用，请勿转发给任何人</div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: { },
  data() {
    return {
      
    };
  },
  mounted () {
   
  },
  methods: {
    goRouter (name) {
      this.$router.push(name)
    },
  }
}
</script>
<style scoped>
  .home-header-inner{
    height: 92px;
    background: #3296FF;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    line-height: 92px;
  }
  .home-header-circle{
    background: url('../assets/header-bg.png') no-repeat;
    background-size: 100% 12px;
    height: 12px;
  }
  .home-main{
    margin: 56px 0;
  }
  .title{
    font-size: 16px;
    margin-bottom: 8px;
  }
  .sub-title{
    font-size: 13px;
  }
  .operation-item{
    height: 84px;
    background: #f6f6f6;
    border: 1px solid #E6E6E6;
    width: 70%;
    margin: 0 auto;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: right;
    line-height: 84px;
    padding: 0 44px;
    font-weight: bold;
    background-repeat: no-repeat ;
    background-size: 58px 52px;
    background-position: 20% bottom;
  }
  .operation-item.subscribe{
    background-image: url('../assets/main-bg1.png');
  }
  .operation-item.search{
    background-image: url('../assets/main-bg2.png');
  }
  .operation-item+.operation-item{
    margin-top: 36px;
  }
  .operation-item:active{
    background-color: #3296FF;
    color: #fff;
  }
  .warning-tip{
    font-size: 13px;
    padding: 20px;
    margin-top: 40px;
  }
</style>
